// extracted by mini-css-extract-plugin
module.exports = {"zoomHelpTag":"ZoomHelpTag-module__zoomHelpTag___zz_SY","zoomInstructions":"ZoomHelpTag-module__zoomInstructions___8_Nxl"};